import * as React from 'react';
import { useEffect, useState } from 'react';
import { Textarea, Container, Header, KeyValuePairs } from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';
import { getNotification, updateNotifications } from 'src/api/notifications';
import { NotificationComments } from 'src/components/notifications/comment';
import { TABLE_CONTENT_TYPE } from 'src/commons/constants';
import { getPhoneToolLink } from 'src/commons/common';

export interface NotificationDetailPageProps {
  activeWorkspace: any;
  setContentType: any;
  match: any;
  activeGroup: string;
  username: string;
}

export const NotificationDetailPage = (props: NotificationDetailPageProps) => {
  const [notification, setNotification] = useState({});

  useEffect(() => {
    props.setContentType(TABLE_CONTENT_TYPE);
    handleRefresh();
  }, []);

  useEffect(() => {
    handleRefresh();
    props.setContentType(TABLE_CONTENT_TYPE);
  }, [props.match.params.NotificationId]);

  const handleRefresh = async () => {
    try {
      const notification = await getNotification({
        NotificationId: props.match.params.NotificationId,
        NotificationOwnerId: props.activeWorkspace ? props.activeWorkspace.workspaceId : props.activeGroup,
      });

      setNotification(notification.Notification);
      await updateNotifications({
        NotificationOwnerId: props.activeWorkspace ? props.activeWorkspace.workspaceId : props.activeGroup,
        NotificationIdList: [notification.Notification.NotificationId],
        MarkRead: true,
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Container header={<Header variant='h2'>{notification['Subject']}</Header>}>
        <Textarea value={notification['Content']} readOnly rows={10} />
      </Container>
      <br />

      <Container header={<Header variant={'h2'}>Details</Header>}>
        <KeyValuePairs
          columns={4}
          items={[
            {
              label: 'Sender',
              value: getPhoneToolLink(notification['SenderId']),
            },
            { label: 'Sender group or workspace', value: notification['NotificationOwnerId'] },
            { label: 'Priority', value: notification['PriorityLevel'] },
            { label: 'Email sent', value: notification['EmailSent'] ? 'Sent' : 'Not sent' },
            { label: 'Create time', value: new Date(notification['CreateTime']).toLocaleString() },
          ].filter((item) => item != undefined)}
        />
      </Container>
      {notification['NotificationBatchId'] && notification['NotificationId'] && (
        <NotificationComments
          {...props}
          notificationBatchId={notification['NotificationBatchId']}
          notificationId={notification['NotificationId']}
        />
      )}
    </>
  );
};
